function Device() {
  this.os_type = '';
  this.net_type = '';
  this.user_agent = '';
  this.android_adv_id = '';
  this.ios_idfa = '';
  this.android_id = '';
  this.package_name = '';
  this.screen_height = '';
  this.device_name = '';
  this.device_id = '';
  this.android_imei = '';
  this.screen_width = '';
  this.os_ver = '';
  this.sdk_ver = '';
  this.language = '';
}

Device.prototype = {
  constructor: Device,
};

export default Device;



// WEBPACK FOOTER //
// ./src/common/js/model/Device.js